'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:glass-regular group-[.toaster]:text-foreground group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl group-[.toaster]:border-0',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:glass-thick group-[.toast]:text-foreground group-[.toast]:rounded-lg group-[.toast]:border-0',
          cancelButton: 'group-[.toast]:glass-thin group-[.toast]:text-muted-foreground group-[.toast]:rounded-lg group-[.toast]:border-0',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
